import { CABINET_DECISIONS_DATA } from './cabinetDecisionsData';

export const MOCK_DATA = {
  stats: {
    projectsOnTrack: 142,
    projectsAtRisk: 34,
    projectsDelayed: 12,
    projectsAbandoned: 3,
    totalValue: 12500000000,
    disbursed: 4200000000,
    deadlineBreaches: 8,
    cabinetDecisionsActive: CABINET_DECISIONS_DATA.stats.activeDecisions,
    cabinetDecisionsOverdue: CABINET_DECISIONS_DATA.stats.overdueDecisions
  },
  ministries: [
    { id: 'MOE', name: 'Ministry of Education, Arts & Culture', score: 45, status: 'At Risk', budget: 14000000000 },
    { id: 'MOHSS', name: 'Ministry of Health & Social Services', score: 62, status: 'On Track', budget: 9000000000 },
    { id: 'MWT', name: 'Ministry of Works & Transport', score: 38, status: 'Delayed', budget: 6500000000 },
    { id: 'MAF', name: 'Ministry of Agriculture, Water & Land Reform', score: 71, status: 'On Track', budget: 2200000000 },
    { id: 'MICT', name: 'Ministry of ICT', score: 85, status: 'On Track', budget: 800000000 },
  ],
  alerts: [
    { id: 1, type: 'breach', severity: 'high', title: 'PPU Non-Compliance Acknowledgment Overdue', message: 'Ministry of Works failed to acknowledge non-compliance notice within 7 days.', entity: 'MWT', daysOverdue: 12, legalBasis: 'PPA S.7(4)' },
    { id: 2, type: 'deadline', severity: 'medium', title: 'NDP6 Quarterly Report Late', message: 'Ministry of Education has not submitted Q3 progress report.', entity: 'MOE', daysOverdue: 5, legalBasis: 'NDP6 IMEP' },
    { id: 3, type: 'risk', severity: 'critical', title: 'Potential Abandonment Detected', message: 'No activity logged for 45 days on Project NAM-2024-0042.', entity: 'MWT', daysOverdue: 45, legalBasis: 'Contract Cl. 14.2' },
    { id: 4, type: 'info', severity: 'low', title: 'Funds Certification Pending', message: 'New procurement waiting for Treasury funds certification.', entity: 'MOHSS', daysOverdue: 2, legalBasis: 'SFA S.14' },
  ],
  ndp6: {
    pillars: [
      { name: 'Economic Advancement', status: 'Behind', progress: 45 },
      { name: 'Social Transformation', status: 'On Track', progress: 72 },
      { name: 'Environmental Sustainability', status: 'On Track', progress: 88 },
      { name: 'Good Governance', status: 'At Risk', progress: 55 },
    ]
  },
  projects: [
    { 
      id: 'NAM-2025-0012', 
      name: 'Windhoek-Okahandja Dual Carriageway Section 4', 
      ministry: 'Ministry of Works & Transport', 
      contractor: 'Aveng Grinaker-LTA', 
      value: 850000000, 
      status: 'Delayed', 
      progress: 65, 
      startDate: '2023-01-15', 
      endDate: '2025-11-30',
      milestone: 'Bridge Deck Construction',
      pillar: 'Economic Advancement'
    },
    { 
      id: 'NAM-2025-0045', 
      name: 'Khomas District Hospital Phase 1', 
      ministry: 'Ministry of Health & Social Services', 
      contractor: 'China Jiangsu Intl', 
      value: 1200000000, 
      status: 'On Track', 
      progress: 22, 
      startDate: '2024-06-01', 
      endDate: '2027-06-01',
      milestone: 'Foundation Works',
      pillar: 'Social Transformation'
    },
    { 
      id: 'NAM-2025-0102', 
      name: 'Rural Electrification: Zambezi Region', 
      ministry: 'Ministry of Mines & Energy', 
      contractor: 'Norelec Namibia', 
      value: 45000000, 
      status: 'On Track', 
      progress: 90, 
      startDate: '2024-02-10', 
      endDate: '2025-04-30',
      milestone: 'Final Commissioning',
      pillar: 'Economic Advancement'
    },
    { 
      id: 'NAM-2024-0882', 
      name: 'Green Scheme Irrigation Expansion', 
      ministry: 'Ministry of Agriculture', 
      contractor: 'AgriBus Dev', 
      value: 120000000, 
      status: 'At Risk', 
      progress: 40, 
      startDate: '2023-09-01', 
      endDate: '2025-09-01',
      milestone: 'Pump Station Installation',
      pillar: 'Economic Advancement'
    },
    { 
      id: 'NAM-2023-0099', 
      name: 'School Renovation Program: Kunene', 
      ministry: 'Ministry of Education', 
      contractor: 'SME Joint Venture', 
      value: 15000000, 
      status: 'Abandoned', 
      progress: 15, 
      startDate: '2023-03-01', 
      endDate: '2023-12-31',
      milestone: 'Roofing',
      pillar: 'Social Transformation'
    }
  ],
  contractors: [
    { name: 'China Jiangsu Intl', contracts: 4, value: 2500000000, score: 92, status: 'Good' },
    { name: 'Aveng Grinaker-LTA', contracts: 2, value: 1200000000, score: 58, status: 'At Risk' },
    { name: 'SME Joint Venture', contracts: 1, value: 15000000, score: 20, status: 'Debarment Alert' },
    { name: 'Norelec Namibia', contracts: 5, value: 230000000, score: 88, status: 'Good' },
  ],
  cabinetDecisions: CABINET_DECISIONS_DATA.decisions,
  cabinetDirectives: CABINET_DECISIONS_DATA.directives,
  cabinetAssignments: CABINET_DECISIONS_DATA.assignments,
  cabinetStats: CABINET_DECISIONS_DATA.stats
};